if ($('.alertClosable').length) {
    $('.alertClosable').append(
        $(document.createElement('button')).prop({
            type: 'button',
            innerHTML: '<span class="button-text"><span class="icon icon-cross"></span><span class="visually-hidden>Close alert</span></span>',
            class: 'button __icononly __small alert-close alertClose'
        })
    );

    $('.alertClose').on( "click", function() {
        console.log('close');
        $('.alertClosable').slideUp();
    });
}
